// extracted by mini-css-extract-plugin
export default {"menuOption":"shared-menu-option-module__menuOption___EpdCc","iconClassName":"shared-menu-option-module__iconClassName___lAr0J"};